import { Directive } from '@angular/core';

@Directive({
  selector: '[appToastMessageIcon]',
  standalone: true,
})
export class ToastMessageIconDirective {}
